/* this file is auto-generated.  DO NOT MODIFY*/
import Questionaire from '../../src/js/modules/Questionaire.js';
import Singleton from '../../src/js/modules/Singleton.js';
import Transient from '../../src/js/modules/Transient.js';

export default [
		Questionaire,
		Singleton,
		Transient
	];

